import React from 'react';
import { Switch } from 'react-router-dom';
import Route from './Route';

import SignIn from '~/pages/SignIn';
import SignUp from '~/pages/SignUp';
import ForgotPassword from '~/pages/ForgotPassword';
import ResetPassword from '~/pages/ForgotPassword/ResetPassword';
import SubjectStudent from '~/pages/Subjects';
import Dashboard from '~/pages/Dashboard';
import Timeline from '~/pages/Timeline';
import Playground from '~/pages/Playground';
import Feedback from '~/pages/Feedback';
import Answer from '~/pages/Answer';
import Mail from '~/pages/Mail';
import JobDetail from '~/pages/JobDetail';
import JobFeedback from '~/pages/JobFeedback';
import Scorecard from '~/pages/Scorecard';
import Conquer from '~/pages/Conquer';
import Profile from '~/pages/Profile';
import Faq from '~/pages/FAQ';
import Tutoring from '~/pages/Tutoring';
import UserProfile from '~/pages/UserProfile';
import Project from '~/pages/Project';

import Admin from '~/pages/Admin';
import Users from '~/pages/Admin/Users';
import Cards from '~/pages/Admin/Cards';
import UpdateCards from '~/pages/Admin/Cards/UpdateCards';
import Level from '~/pages/Admin/Level';
import LevelUpdate from '~/pages/Admin/Level/Update';
import Subject from '~/pages/Admin/Subject';
import SubjectUpdate from '~/pages/Admin/Subject/Update';
import Modules from '~/pages/Admin/Modules';
import ModulesUpdate from '~/pages/Admin/Modules/Update';
import Challenges from '~/pages/Admin/Challenges';
import UpdateChallenge from '~/pages/Admin/Challenges/UpdateChallenge';
import Jobs from '~/pages/Admin/Jobs';
import JobsUpdate from '~/pages/Admin/Jobs/UpdateJob';
import Files from '~/pages/Admin/File';

import EducatorChallenge from '~/pages/Educator/Challenges';
import EducatorJobs from '~/pages/Educator/Jobs';
import EducatorTutoria from '~/pages/Educator/Tutoria';
import EducatorUsers from '~/pages/Educator/Users';

// import Mobile from '~/pages/mobile';

export default function Routes() {
  return (
    <Switch>
      <Route path="/" exact component={SignIn} />
      <Route path="/register" component={SignUp} />
      <Route path="/forgotpassword" component={ForgotPassword} exact />
      <Route path="/forgotpassword/reset/:id" component={ResetPassword} />

      <Route path="/subjects" component={SubjectStudent} isPrivate />
      <Route path="/dashboard/:id" component={Dashboard} isPrivate />
      <Route path="/mail" component={Mail} isPrivate />
      <Route path="/jobs/:id" component={JobDetail} isPrivate />
      <Route path="/scorecard" component={Scorecard} isPrivate />
      <Route path="/conquer" component={Conquer} isPrivate />
      <Route path="/profile" component={Profile} isPrivate />
      <Route path="/faq" component={Faq} isPrivate />
      <Route path="/tutoring" component={Tutoring} isPrivate />
      <Route path="/userprofile/:id" component={UserProfile} isPrivate />

      <Route path="/timeline/:id" component={Timeline} isPrivate />
      <Route path="/playground/:id" component={Playground} isPrivate />
      <Route path="/feedback/:id" component={Feedback} isPrivate />
      <Route path="/jobfeedback/:id" component={JobFeedback} isPrivate />
      <Route path="/answer/:id" component={Answer} isPrivate />

      <Route path="/admin" component={Admin} isPrivate />
      <Route path="/users" component={Users} isPrivate />
      <Route path="/card" component={Cards} isPrivate exact />
      <Route path="/card/:id" component={UpdateCards} isPrivate />
      <Route path="/level" component={Level} isPrivate />
      <Route path="/levelupdate/:id" component={LevelUpdate} isPrivate />
      <Route path="/subject" component={Subject} isPrivate />
      <Route path="/subjectupdate/:id" component={SubjectUpdate} isPrivate />
      <Route path="/module" component={Modules} isPrivate />
      <Route path="/moduleupdate/:id" component={ModulesUpdate} isPrivate />
      <Route path="/challenge" component={Challenges} isPrivate exact />
      <Route
        path="/updatechallenge/:id"
        component={UpdateChallenge}
        isPrivate
      />
      <Route path="/jobs" component={Jobs} isPrivate exact />
      <Route path="/updatejob/:id" component={JobsUpdate} isPrivate exact />
      <Route path="/file" component={Files} isPrivate />
      <Route path="/project/:id" component={Project} isPrivate />

      <Route
        path="/educatorChallenge"
        component={EducatorChallenge}
        isPrivate
      />
      <Route path="/educatorJobs" component={EducatorJobs} isPrivate />
      <Route path="/educatorTutoria" component={EducatorTutoria} isPrivate />
      <Route path="/educatorUsers" component={EducatorUsers} isPrivate />

      {/* <Route path="/mobile" component={Mobile} isPrivate /> */}

      <Route
        path="/"
        component={() => <h1>Erro 404: Essa página nāo existe.</h1>}
      />
    </Switch>
  );
}
